import React, { Fragment, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.webp";
import logoicon from "../assets/images/glogo.webp";

function Leftmenu({ collapsed, setCollapsed }) {
  const location = useLocation();
  const SideMenuRef = useRef(null);
  const user = useSelector((store) => store.user);
  const [openMenus, setOpenMenus] = useState([]);

  const handleToggleMenu = (menuIndex) => {
    if (openMenus.includes(menuIndex)) {
      setOpenMenus(openMenus.filter((index) => index !== menuIndex));
    } else {
      setOpenMenus([...openMenus, menuIndex]);
    }
  };

  const isMenuOpen = (menuIndex) => openMenus.includes(menuIndex);
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  const toggleSidebar = () => setCollapsed(!collapsed);

  const menuItems = [
    {
      id: 0,
      icon: "bi-speedometer2",
      label: "Dashboard",
      link: "/dashboard",
      single: true
    },
    {
      id: 1,
      icon: "bi-collection",
      label: "Attributes",
      children: [
        { label: "States", link: "/state" },
        { label: "Cities", link: "/city" },
        { label: "Salary Types", link: "/salary_type" },
        { label: "Industry Types", link: "/industry_type" },
        { label: "Job Positions", link: "/jobs_position" },
        { label: "Employment Types", link: "/employment_type" },
        { label: "Skills", link: "/skills" },
        { label: "Experience", link: "/experiance" },
        { label: "Education", link: "/education" },
        { label: "Work Places", link: "/work_place" },
        { label: "Promotions", link: "/promote" },
      ]
    },
    {
      id: 2,
      icon: "bi-people",
      label: "Users",
      children: [
        { label: "Candidates", link: "/candidate" },
        { label: "Employers", link: "/employer" },
      ]
    },
    {
      id: 5,
      icon: "bi-briefcase",
      label: "Jobs",
      children: [
        { label: "Jobs List", link: "/jobs_list" },
        { label: "Applied Jobs", link: "/applyed_job" },
      ]
    },
    {
      id: 6,
      icon: "bi-gear",
      label: "Settings",
      children: [
        { label: "General Settings", link: "/settings" },
        { label: "Pages", link: "/pages" },
        { label: "Email Templates", link: "/email_templates" },
        { label: "Bulk Import/Export", link: "/bulk_import_export" },
      ]
    }
  ];

  return (
    <Fragment>
      <aside
        ref={SideMenuRef}
        id="sidebar"
        className={`fixed top-0 left-0 z-40 h-screen transition-all duration-300 ${
          collapsed ? "w-20" : "w-64"
        }`}
        aria-label="Sidebar"
      >
        <div className="h-full flex flex-col bg-gradient-to-b from-slate-800 via-slate-900 to-slate-950 shadow-xl">
          <div className={`p-4 border-b border-slate-700/50 flex items-center ${collapsed ? 'justify-center' : 'justify-between'}`}>
            <Link to="/dashboard" className="flex items-center justify-center">
              <img
                className={`transition-all duration-300 ${collapsed ? 'h-8' : 'h-10'}`}
                src={collapsed ? logoicon : logo}
                alt="Logo"
              />
            </Link>
            <button
              type="button"
              className={`p-2 rounded-lg hover:bg-slate-700 transition-colors ${collapsed ? 'hidden' : ''}`}
              onClick={toggleSidebar}
            >
              <i className="bi bi-chevron-left text-slate-400"></i>
            </button>
          </div>

          {collapsed && (
            <button
              type="button"
              className="p-3 mx-auto mt-2 rounded-lg hover:bg-slate-700 transition-colors"
              onClick={toggleSidebar}
            >
              <i className="bi bi-chevron-right text-slate-400"></i>
            </button>
          )}

          <nav className="flex-1 overflow-y-auto py-4 px-3 scrollbar-thin scrollbar-thumb-slate-700 scrollbar-track-transparent">
            <ul className="space-y-1">
              {menuItems.map((item) => (
                <li key={item.id}>
                  {item.single ? (
                    <Link
                      to={item.link}
                      className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 group ${
                        isActive(item.link)
                          ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-500/25'
                          : 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
                      }`}
                      title={collapsed ? item.label : ''}
                    >
                      <i className={`bi ${item.icon} text-lg ${collapsed ? 'mx-auto' : ''}`}></i>
                      {!collapsed && <span className="font-medium">{item.label}</span>}
                    </Link>
                  ) : (
                    <>
                      <button
                        type="button"
                        onClick={() => handleToggleMenu(item.id)}
                        className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                          isMenuOpen(item.id)
                            ? 'bg-slate-700/50 text-white'
                            : 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
                        }`}
                        title={collapsed ? item.label : ''}
                      >
                        <i className={`bi ${item.icon} text-lg ${collapsed ? 'mx-auto' : ''}`}></i>
                        {!collapsed && (
                          <>
                            <span className="flex-1 text-left font-medium">{item.label}</span>
                            <i className={`bi bi-chevron-down text-xs transition-transform duration-200 ${isMenuOpen(item.id) ? 'rotate-180' : ''}`}></i>
                          </>
                        )}
                      </button>
                      {!collapsed && (
                        <ul className={`mt-1 space-y-1 overflow-hidden transition-all duration-200 ${isMenuOpen(item.id) ? 'max-h-[800px]' : 'max-h-0'}`}>
                          {item.children?.map((child, idx) => (
                            <li key={idx}>
                              <Link
                                to={child.link}
                                className={`flex items-center gap-2 pl-12 pr-4 py-2.5 rounded-xl transition-all duration-200 ${
                                  isActive(child.link)
                                    ? 'bg-blue-500/20 text-blue-400 font-medium'
                                    : 'text-slate-400 hover:bg-slate-700/30 hover:text-slate-200'
                                }`}
                              >
                                <span className={`w-1.5 h-1.5 rounded-full ${isActive(child.link) ? 'bg-blue-400' : 'bg-slate-500'}`}></span>
                                <span className="text-sm">{child.label}</span>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div className={`p-4 border-t border-slate-700/50 ${collapsed ? 'px-2' : ''}`}>
            <div className={`flex items-center gap-3 ${collapsed ? 'justify-center' : ''}`}>
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold shadow-lg flex-shrink-0">
                {user?.name?.charAt(0)?.toUpperCase() || 'A'}
              </div>
              {!collapsed && (
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-white truncate">{user?.name || 'Admin'}</p>
                  <p className="text-xs text-slate-400 truncate">{user?.email || 'admin@example.com'}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </aside>
    </Fragment>
  );
}

export default Leftmenu;
